import React, {Component} from 'react'
import './Layout/NotFound.css'
import {browserHistory} from 'react-router'
import {Actions} from 'jumpstate'

class NotFound extends Component {
  render () {
    const image = `${window.location.protocol}//${window.location.host}/404.png`
    const sendToNewHorse = () => {
      Actions.setNewHorseDetails({
        name: /^[- _a-zA-Z0-9.']+$/.test(this.props.route.query.q) ? this.props.route.query.q : '',
        name_fa: /^[- _a-zA-Z0-9.']+$/.test(this.props.route.query.q) ? '' : this.props.route.query.q
      })
      browserHistory.push('/new-horse')
    }
    return (
      <div className="not-found">
        <img className="not-found-image" src={image} alt="not-found" />
        <p className="not-found-text">
          <span className="not-found-404">۴۰۴</span> موردی یافت نشد.
          <div className="guide-box">
            <p>می‌توانید:</p>
            <ul>
              {this.props.route.pathname === '/result' &&
              <li><span className="query">{this.props.route.query.q}</span>را <a onClick={sendToNewHorse}>ثبت کنید</a></li>
              }
              <li>با تغییر کلمه، جستجوی دیگری انجام دهید</li>
            </ul>
          </div>
        </p>
      </div>
    )
  }
}

NotFound.propTypes = {
  route: React.PropTypes.object
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/Common/NotFound/NotFound.js